import React, { useEffect, useRef, useState } from 'react'
import { useForm } from 'react-hook-form';
import { getApiSetting, postApiSetting, typeNumber } from '../assets/functions';
import Navbar from '../components/Navbar';
import Pagination, { PagiSearch } from '../components/Pagination';
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { TableStatusRow, StatusBadge } from "../components/UI";

export default function AddReseller ({setAuth}) {
     const navigate = useNavigate();

    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const { register: register2, handleSubmit: handleSubmit2, reset:reset2, formState: { errors: errors2 } } = useForm();


    const [transactinoData, setTransactinoData] = useState([]);
    const [startOffset, setStartOffset] = useState(0);
    const [search, setSearch] = useState('');
    const [tableDataStatus, setTableDataStatus] = useState('');
    const [refreshTable, setRefreshTable] = useState(false);
        const [editData,SetEditData] = useState({})
        const [editReModal,SetEditReModal] = useState(false)
        const [reUserId,SetReUserId] = useState("")

    const closeRef = useRef(null);
    const reStatusRef = useRef(null);
    const prodRef = useRef(null);

    const itemsPerPage = 10;
    const searchData = transactinoData.filter(item => Object.values(item).join("").toString().toLowerCase().includes(search.toLowerCase()))
    const endOffset = startOffset + itemsPerPage;
    const currentItems = searchData.slice(startOffset, endOffset)
    const pageCount = Math.ceil(searchData.length / itemsPerPage)

    const [resellerEditData, setResellerEditData] = useState({});
    const [addResellerModal, setAddResellerModal] = useState(false);
    const [updateResellerModal, setUpdateResellerModal] = useState(false);

    useEffect(()=>{
        setTableDataStatus('Loading...');
        (async()=>{
            try {
                // let res = await fetch('/admin/api/Admin/Processor/fetchProcessorDetails', getApiSetting());
                let res = await fetch('/Admin/api/Admin/viewResellerList', getApiSetting());
                let result 
                // console.log("res--",res)
                // console.log("result---",result)
                if(res.status === 200){
                    result = await res.json();
                    if(result.data < 1){
                        // console.log("inside Success")
                        setTableDataStatus('Not Found')
                    }else{
                       
                        let data = result.data.sort(function(a, b) {
                            let c = new Date(a.creationDate);
                            let d = new Date(b.creationDate);
                            return d-c;
                        })
                        setTableDataStatus('')
                        setTransactinoData(data)
                        closeRef.current.click();
                    }
                }
                 else if(res.status === 401)
                                {
                                    
                                    setAuth(false)
                                    toast.error("Session Expired !", {position: 'top-center',});
                                    navigate("/");                  
                                    sessionStorage.clear();
                                }
            } catch (error) { console.log(error) }
        })()
    },[refreshTable])

    const submitProcForm = async (data) => {
        // console.log("data---",data)
        
        let reProducts = data.reProducts.toString();
        let settings = postApiSetting({...data,reProducts})
        // console.log("settings---",settings)
    
        try {    
            // console.log("---editData.length---",editData.length)
            let res = await fetch('/Admin/api/Admin/addReseller', settings);
            let result 
            // console.log(res)
            // console.log(result)
            if(res.status !== 200){
                if(res.status === 401)
                {
                    
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
                else{
                    alert('something went wrong : '+ res.status)
                }
            }else{
                result = await res.json();
                if(result.statusCode == 0){
                    alert('SUCCESS : '+result.status)   
                    setRefreshTable(refresh => !refresh)
                    setAddResellerModal(prev=>!prev)
                    
                }else{
                    alert('FAILED : '+result.status)
                    setAddResellerModal(prev=>!prev)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    const submitUpdateForm = async (data) => {
        // console.log("data---",data)
            
        
        let reProducts = data.reProducts.toString();
        let settings = postApiSetting({...data,reProducts,reUserId})
        // console.log("settings---",settings)
    
        try {    
            // console.log("---editData.length---",editData.length)
            let res = await fetch('/Admin/api/Admin/updateReseller' , settings);
            let result
            // console.log(res)
            // console.log(result)
            if(res.status !== 200){
                if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }else{
                alert('something went wrong : ' + res.status)
            }
            }else{
                result = await res.json();
                if(result.statusCode == 0){
                    alert('SUCCESS : '+result.status)  

                    setRefreshTable(prev=>!prev)
                    setUpdateResellerModal(prev=>!prev)
                    
                }else{
                    alert('FAILED : '+result.status)
                    setUpdateResellerModal(prev=>!prev)
                }
            }
        } catch (error) {
            console.log(error)
        }
    }
    

    const editProc1 = (item) => {
        SetEditReModal(prev=>!prev)
        reset2()
        // SetEditData(updatedItem);
        const types = item.reProducts;
        const includesPayin = types.split(",").includes("PAYIN");
        const includesPayout = types.split(",").includes("PAYOUT");
        const updatedItem = {...item,includesPayin,includesPayout};
    //    console.log("includesPayin-",includesPayin)
    //    console.log("includesPayout-",includesPayout)
        SetEditData(updatedItem);
    
        
    };

        useEffect(()=>{
            if(reStatusRef.current && resellerEditData.status){
                reStatusRef.current.querySelector(`input[value="${resellerEditData.status}"]`).checked = true;
            }
            if (prodRef.current && resellerEditData.status) {
                let modeList = resellerEditData.reProducts.split(',');
                modeList.forEach((item) => {
                  prodRef.current.querySelector(`input[value="${item}"]`).checked = true;
                });
              }
              


        },[addResellerModal,updateResellerModal])
    

    const editReseller = (item) => {
       // reset2()
       SetReUserId(item.reUserId)
        // console.log("resellerEditData-->>",resellerEditData)
        const types = item.reProducts;
        const includesPayin = types.split(",").includes("PAYIN");
        const includesPayout = types.split(",").includes("PAYOUT");
        const updatedItem = {...item,includesPayin,includesPayout};

    setUpdateResellerModal(true)
        setResellerEditData(updatedItem)
    }

    const openAddReseller = () => {
        reset()
        setAddResellerModal(true)
        setResellerEditData({})
    }
    return (<>
        {/* <SidebarNavigation /> */}
        <ToastContainer />
        <section className="transaction-page">
            <Navbar title="RESELLER MANAGEMENT" />
            <div className="container-fluid pe-3">
                <div className="main-content my-3">
                    <div className="page-toolbar justify-content-between mb-3">
                        <h6 className="mb-0">Reseller Management</h6>
                        <button type="button" className="btn btn-sm text-white _themebg-0" onClick={openAddReseller}>
                            <i className="fa-solid fa-plus"></i> Add Reseller
                        </button>
                    </div>

                    <PagiSearch setSearch={setSearch}
                    totalEntries={searchData.length}
                    setStartOffset={setStartOffset}
                    setTableDataStatus={setTableDataStatus} />

                    <div className="table-responsive my-2 com-table">
                    <table className="table table-bordered mb-1">
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>User Id</th>
                                <th>Name</th>
                                <th>Company Name</th>
                                <th>Mobile No.</th>
                                <th>Email</th>
                                <th>Password</th>
                                <th>CreationDate</th>
                                <th>Products</th>
                                <th>Status</th>
                                <th>Action</th>

                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.length < 1 ? <TableStatusRow colSpan={11} status={tableDataStatus} /> :
                            currentItems.map((item,index) => {
                                return (
                                <tr key={index}>
                                    <td>{startOffset + index + 1}</td>
                                    <td>{item.reUserId}</td>
                                    <td>{item.reName}</td>
                                    <td>{item.reCompanyName}</td>
                                    <td>{item.reMobileNo}</td>
                                    <td>{item.reEmail}</td>
                                    <td>{item.password}</td>
                                    <td>{item.reCreationDate}</td>
                                    <td>{item.reProducts}</td>
                                    <td><StatusBadge status={item.status} /></td>
                                    
                                    <td>
                                        {/* <button type="button" className="btn btn-sm text-white _themebg-0" onClick={()=>editProc(item)} data-bs-toggle="modal" data-bs-target="#procModal" id='editBtn'>Edit</button> */}
                                        <button type="button" className="btn btn-sm text-white _themebg-0" onClick={()=>editReseller(item)}>Edit</button>
                                        {/* <button className="btn btn-sm text-danger" onClick={()=>deleteProc(item.id)}><i className="fa-solid fa-trash-can"></i></button> */}
                                    </td>
                                </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    </div>

                    <Pagination setStartOffset={setStartOffset}
                    pageCount={pageCount} itemsPerPage={itemsPerPage} />

                </div>
            </div>
        </section>

      

        {/* -------------------Add Reseller Modal-------------------------- */}
        
        <Modal show={addResellerModal} onHide={() => setAddResellerModal(false)} keyboard={false} size="md">
            <Modal.Header className="p-2" closeButton>
                <Modal.Title className="w-100 text-center text-secondary">
                  <h5 className="modal-title ms-3" id="exampleModalLabel">{Object.keys(resellerEditData).length > 0 ? 'UPDATE ' : 'ADD '} RESELLER</h5>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <form className="px-3 pb-2" onSubmit={handleSubmit(submitProcForm)}> 
                        <div className="row">
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Reseller Name <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none" 
                                 {...register('reName', { required : { value:true, message:"This field is required" } })} disabled={Object.keys(resellerEditData).length > 0} value={resellerEditData?.reName}/>
                                {errors.procMid && <strong className="text-danger"><small>{errors.procMid.message}</small></strong>}
                            </div>
                           {/* {console.log("resellerEditData-",resellerEditData)} */}

                            <div className="col-md-6 mb-2">
                                <label className="form-label">Company Name<strong className='text-danger'>*</strong></label>
                            <input type="text" className="form-control shadow-none"
                                {...register('reCompanyName', { required : { message:"This field is required" } })} disabled={Object.keys(resellerEditData).length > 0} value={resellerEditData?.reCompanyName}/>                         
                              {errors.procCred_1 && <strong className="text-danger"><small>{errors.procCred_1.message}</small></strong>}
                           </div>
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Mobile No.<strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none"
                                {...register('reMobileNo', { required : { value:true, message:"This field is required" } })} 
                                onInput={typeNumber} maxLength={10} disabled={Object.keys(resellerEditData).length > 0} defaultValue={resellerEditData?.reMobileNo}/>
                                {errors.procCred_2 && <strong className="text-danger"><small>{errors.procCred_2.message}</small></strong>}
                            </div>
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Email<strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none"
                                {...register('reEmail', { required : { value:true, message:"This field is required" } })} disabled={Object.keys(resellerEditData).length > 0} defaultValue={resellerEditData?.reEmail}/>
                                {errors.procCred_3 && <strong className="text-danger"><small>{errors.procCred_3.message}</small></strong>}
                            </div>

                                <div className='col-md-12 mb-2'>
                                    <label className="form-label">Product <strong className='text-danger'>*</strong></label>
                                    <ul className="list-group list-group-horizontal" ref={prodRef}>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                             
                                              <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="PAYIN" id="prodcheck_1" {...register('reProducts')}/>
                                                <label className="form-check-label" htmlFor="prodcheck_1">PAYIN</label>
                                            </div>
                                        </li>
                                        <li className="list-group-item">
                                            <div className="form-check">
                                          
                                            <input className="form-check-input me-2 shadow-none _editP" type="checkbox" value="PAYOUT" id="prodcheck_2" {...register('reProducts')} />
                                            <label className="form-check-label" htmlFor="prodcheck_2">PAYOUT</label>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                        <div className='col-12 mt-2'>
                            <label className="form-label">Status <strong className='text-danger'>*</strong></label>
                            <ul className="list-group list-group-horizontal" ref={reStatusRef}>
                            <li className="list-group-item">
                                <div className="form-check">
                              <input className="form-check-input shadow-none" type="radio" {...register('status')} value="Activate" id="restatusradio_1" />
                                    <label className="form-check-label" htmlFor="restatusradio_1">
                                        Activate
                                    </label>
                                </div>
                            </li>
                            <li className="list-group-item">
                                <div className="form-check">
                             <input className="form-check-input shadow-none" type="radio" {...register('status')} value="Deactivate" id="restatusradio_2" />
                                    <label className="form-check-label" htmlFor="restatusradio_2">
                                        Deactivate
                                    </label>
                                </div>
                            </li>
                        </ul>



                        </div>


                            
                        </div>
                        <div className="text-center mt-3">
                            <button type="submit" className="btn _themebg-0 text-white ms-2" style={{fontWeight: "500"}}>{Object.keys(resellerEditData).length > 0? "UPDATE":"ADD"  } RESELLER</button>
                            <button type="button" className="btn btn-danger ms-2" data-bs-dismiss="modal" onClick={()=>{setAddResellerModal(false)}} style={{fontWeight: "500"}}>CLOSE</button>
                        </div>
                    </form>
            </Modal.Body>
        </Modal>
        
        {/* -------------------Modal End-------------------------- */}


                {/* -------------------Update Reseller Modal-------------------------- */}
        
                <Modal show={updateResellerModal} onHide={() => setUpdateResellerModal(false)} keyboard={false} size="md">
            <Modal.Header className="p-2" closeButton>
                <Modal.Title className="w-100 text-center text-secondary">
                  <h5 className="modal-title ms-3" id="exampleModalLabel">{Object.keys(resellerEditData).length > 0 ? 'UPDATE ' : 'ADD '} RESELLER</h5>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <form className="px-3 pb-2" onSubmit={handleSubmit(submitUpdateForm)}> 
                        <div className="row">
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Reseller Name <strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none" 
                                 {...register('reName', { required : { value:false, message:"This field is required" } })} disabled={Object.keys(resellerEditData).length > 0} value={resellerEditData?.reName}/>
                                {errors.procMid && <strong className="text-danger"><small>{errors.procMid.message}</small></strong>}
                            </div>
                           {/* {console.log("resellerEditData-",resellerEditData)} */}

                            <div className="col-md-6 mb-2">
                                <label className="form-label">Company Name<strong className='text-danger'>*</strong></label>
                            <input type="text" className="form-control shadow-none"
                                {...register('reCompanyName', { required : {value:false, message:"This field is required" } })} disabled={Object.keys(resellerEditData).length > 0} value={resellerEditData?.reCompanyName}/>                         
                              {errors.procCred_1 && <strong className="text-danger"><small>{errors.procCred_1.message}</small></strong>}
                           </div>
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Mobile No.<strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none"
                                {...register('reMobileNo', { required : { value:false, message:"This field is required" } })} 
                                onInput={typeNumber} max={10} disabled={Object.keys(resellerEditData).length > 0} defaultValue={resellerEditData?.reMobileNo}/>
                                {errors.procCred_2 && <strong className="text-danger"><small>{errors.procCred_2.message}</small></strong>}
                            </div>
                            <div className="col-md-6 mb-2">
                                <label className="form-label">Email<strong className='text-danger'>*</strong></label>
                                <input type="text" className="form-control shadow-none"
                                {...register('reEmail', { required : { value:false, message:"This field is required" } })} disabled={Object.keys(resellerEditData).length > 0} defaultValue={resellerEditData?.reEmail}/>
                                {errors.procCred_3 && <strong className="text-danger"><small>{errors.procCred_3.message}</small></strong>}
                            </div>

                                <div className='col-md-12 mb-2'>
                                    <label className="form-label">Product <strong className='text-danger'>*</strong></label>
                                    

<ul className="list-group list-group-horizontal">
  {['PAYIN', 'PAYOUT'].map((product, index) => (
    <li key={product} className="list-group-item">
      <div className="form-check">
        <input
          className="form-check-input me-2 shadow-none _editP"
          type="checkbox"
          value={product}
          id={`prodcheck_${index + 1}`}
          {...register('reProducts')}
          defaultChecked={resellerEditData?.reProducts?.split(',').includes(product)}
        />
        <label className="form-check-label" htmlFor={`prodcheck_${index + 1}`}>
          {product}
        </label>
      </div>
    </li>
  ))}
</ul>



                                </div>

                        <div className='col-12 mt-2'>
                            <label className="form-label">Status <strong className='text-danger'>*</strong></label>
                            <ul className="list-group list-group-horizontal" ref={reStatusRef}>
                            <li className="list-group-item">
                                <div className="form-check">
                              <input className="form-check-input shadow-none" type="radio" {...register('status')} value="Activate" id="restatusradio_1" />
                                    <label className="form-check-label" htmlFor="restatusradio_1">
                                        Activate
                                    </label>
                                </div>
                            </li>
                            <li className="list-group-item">
                                <div className="form-check">
                             <input className="form-check-input shadow-none" type="radio" {...register('status')} value="Deactivate" id="restatusradio_2" />
                                    <label className="form-check-label" htmlFor="restatusradio_2">
                                        Deactivate
                                    </label>
                                </div>
                            </li>
                        </ul>



                        </div>


                            
                        </div>
                        <div className="text-center mt-3">
                            <button type="submit" className="btn _themebg-0 text-white ms-2" style={{fontWeight: "500"}}>{Object.keys(resellerEditData).length > 0? "UPDATE":"ADD"  } RESELLER</button>
                            <button type="button" className="btn btn-danger ms-2" data-bs-dismiss="modal" onClick={()=>{setUpdateResellerModal(false)}} style={{fontWeight: "500"}}>CLOSE</button>
                        </div>
                    </form>
            </Modal.Body>
        </Modal>
        
        {/* -------------------Update Reseller Modal-------------------------- */}


    


    </>)
}

